import { render } from "./clock-v4.vue?vue&type=template&id=2fbd7b0c&ts=true"
import script from "./clock-v4.vue?vue&type=script&lang=ts"
export * from "./clock-v4.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__